import { Drawer } from "@mui/material";
import React, { Dispatch, SetStateAction, useState } from "react";
import { rightSideDrawerStyles } from "#next/utils/sharedStyles";
import { trpc } from "#next/utils/trpc";
import {
  TPreviewState,
  TPreviewResult,
} from "#next/components/search-builder/shared";
import LoadingContent from "#next/components/reusable/LoadingContent";
import { RightSideDrawerContent } from "#next/components/preview/interface/RightSideDrawerContent";

export const RightSideDrawer = ({
  previewState,
  setPreviewState,
}: {
  previewState: TPreviewState;
  setPreviewState: Dispatch<SetStateAction<TPreviewState>>;
}) => {
  const { groupBlock, filterSettings, isPreviewing } = previewState;
  const [previewResponse, setPreviewResponse] = useState<TPreviewResult | null>(
    null,
  );

  const handleClose = () => {
    setPreviewState({
      groupBlock: null,
      filterSettings: filterSettings,
      isPreviewing: false,
    });
  };

  const runSearchBuilderPreview =
    trpc.savedSearch.runSearchBuilderPreview.useMutation({
      retry: false,
      onSuccess: (data) => {
        setPreviewResponse(data);
      },
    });

  if (!groupBlock) return;

  if (!runSearchBuilderPreview.isLoading) {
    runSearchBuilderPreview.mutate({ groupBlock, filterSettings });
  }

  return (
    <Drawer
      sx={rightSideDrawerStyles}
      variant="persistent"
      anchor="right"
      open={isPreviewing}
    >
      {!previewResponse ? (
        <LoadingContent />
      ) : (
        <RightSideDrawerContent
          data={previewResponse}
          handleDrawerClose={handleClose}
        />
      )}
    </Drawer>
  );
};
